import React, { Component } from 'react';
import styled from 'styled-components';
import $ from 'jquery';

import Button from './Button';
import media from '../styles/media';

class Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: '',
      lastName: '',
      email: '',
      realtor: '',
    };
    this.label = 'Submit';

    this.handleFirstName = this.handleFirstName.bind(this);
    this.handleLastName = this.handleLastName.bind(this);
    this.handleEmail = this.handleEmail.bind(this);
    this.handleRadioButton = this.handleRadioButton.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleFirstName(e) {
    this.setState({
      firstName: e.target.value,
    });
  }
  handleLastName(e) {
    this.setState({
      lastName: e.target.value,
    });
  }

  handleEmail(e) {
    this.setState({
      email: e.target.value,
    });
  }

  handleRadioButton(value) {
    this.setState({
      realtor: value,
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({
      firstName: '',
      lastName: '',
      email: '',
      realtor: '',
    });

    $.ajax({
      url: 'https://alliance.bamcommunications.ca/mailer-trellis.php',
      type: 'POST',
      crossDomain: true,
      data: {
        form_firstName: this.state.firstName,
        form_lastName: this.state.lastName,
        form_email: this.state.email,
        form_realtor: this.state.realtor,
      },
      cache: false,
      success: function(data) {
        // Success..
        window.location = 'thankyou';
      }.bind(this),
      // Fail..
      error: function(xhr, status, err) {
        console.log(xhr, status);
        console.log(err);
        // this.setState({
        //   contactEmail: 'danger',
        //   contactMessage: '<h1>Sorry</p>',
        // });
      }.bind(this),
    });
  }

  render() {
    return (
      <Root>
        <h2>Be the first to know</h2>
        <p>
          Register to be the first to learn about our upcoming projects, VIP
          early access or special offers.
        </p>
        <form onSubmit={this.handleSubmit}>
          <input
            type="text"
            placeholder="First Name"
            value={this.state.firstName}
            onChange={this.handleFirstName}
            required
          />
          <input
            type="text"
            placeholder="Last Name"
            value={this.state.lastName}
            onChange={this.handleLastName}
            required
          />
          <input
            type="text"
            placeholder="Email Address"
            value={this.state.email}
            onChange={this.handleEmail}
            required
          />
          <h4>Are you a realtor?</h4>
          <RadioContainer>
            <div>
              <input
                id="radioYes"
                name="radio"
                type="radio"
                checked={this.state.realtor === 'yes'}
                onChange={() => this.handleRadioButton('yes')}
              />
              <label for="radioYes">Yes</label>
              <RadioMark />
            </div>
            <div>
              <input
                id="radioNo"
                name="radio"
                type="radio"
                checked={this.state.realtor === 'no'}
                onChange={() => this.handleRadioButton('no')}
              />
              <label for="radioNo">No</label>
              <RadioMark />
            </div>
          </RadioContainer>
          <Button label={this.label} type="submit" />
        </form>
        <Copyright>
          Copyright © TRELLIS PROPERTIES. All rights reserved.
        </Copyright>
      </Root>
    );
  }
}

export default Form;

const Copyright = styled.h4`
  display: none;
  @media (min-width: ${media.md}) {
    display: block;
    margin-top: 130px !important;
  }
`;

const RadioContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  margin-bottom: 30px;
  div {
    display: block;
    position: relative;
    padding-left: 44px;
    padding-top: 13px;
    margin-bottom: 12px;
    margin-left: 0%;
    cursor: pointer;
    font-size: 16px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      left: 0px;
      height: 20px;
      width: 20px;
      z-index: 1;
      top: 6px;
      &:checked ~ ${RadioMark} {
        background-color: white;
      }
      &:checked ~ ${RadioMark}:after {
        display: block;
      }
    }
  }
  div:nth-child(2) {
    margin-left: 0px;
  }
`;

const RadioMark = styled.span`
  & {
    position: absolute;
    top: 5px;
    left: 0;
    height: 35px;
    width: 35px;
    background-color: white;
    border: 1px solid black;
    border-radius: 50%;
  }
  &:after {
    content: '';
    position: absolute;
    display: none;
    top: 8px;
    left: 8.5px;
    width: 15.5px;
    height: 15.5px;
    border-radius: 50%;
    background: #f57f29;
  }
`;

const Root = styled.div`
  @media (min-width: ${media.md}) {
    margin-left: 200px;
    padding-top: 130px;
    width: 43%;
    div:nth-of-type(1) {
      order: 0 !important;
    }
  }
  padding-top: 80px;
  padding-left: 25px;
  padding-right: 25px;
  form {
    display: flex;
    flex-direction: column;
  }
  p {
    width: 303px;
    margin-top: 25px;
    margin-bottom: 15px;

    @media (min-width: ${media.sm}) {
      width: 400px;
    }
  }
  h2 {
    font-size: 24px;
  }
  h4 {
    margin-bottom: 0px;
    margin-top: 50px;
  }
  input {
    height: 50px;
    border: 0;
    outline: 0;
    background: transparent;
    border-bottom: 1px solid #0a0203;
    ::-webkit-input-placeholder {
      font-family: 'Source Sans Pro Semi';
      font-size: 12px;
      color: black;
      letter-spacing: 2px;
      text-transform: uppercase;
    }
  }

  button {
    margin: 0 auto;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Form.js